import request from '@/utils/request'

/**
 * 查询订单信息
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryStoreOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询订单商品
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryStoreOrderCart(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrderCart',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询核销单号
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listStoreOrderWriteoff(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.listStoreOrderWriteoff',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 完成备货
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function stockUpStoreOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.stockUpStoreOrder',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}